module.exports = __webpack_public_path__ + "static/media/sawtooth.20aff9ca.svg";